<template>
  <div class="wt-subtitles-page">
    <layout-general>
      <layout-header slot="header"></layout-header>
      <main-stage slot="main">
        <subtitles-stage :active="true" :primary="true"></subtitles-stage>
      </main-stage>
      <subtitles-editor slot="left"></subtitles-editor>
      <subtitles-apply-cancel slot="footer"></subtitles-apply-cancel>
    </layout-general>
  </div>
</template>
<script>
import LayoutGeneral from 'AssetEditor/layouts/LayoutGeneral.vue';
import LayoutHeader from 'AssetEditor/layouts/LayoutHeader.vue';
import SubtitlesApplyCancel from 'AssetEditor/functionality/Subtitles/SubtitlesApplyCancel.vue';
import SubtitlesEditor from 'AssetEditor/functionality/Subtitles/SubtitlesEditor.vue';
import SubtitlesStage from 'AssetEditor/functionality/Subtitles/SubtitlesStage.vue';
import MainStage from 'AssetEditor/functionality/Stage/MainStage.vue';

export default {
  components: {
    LayoutGeneral,
    LayoutHeader,
    SubtitlesApplyCancel,
    SubtitlesEditor,
    SubtitlesStage,
    MainStage,
  },
};
</script>
